// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PicasaOutlinedSvg from "@fishx/icons-svg/es/asn/PicasaOutlined";
import FishxIcon from '../components/FishxIcon';

var PicasaOutlined = function PicasaOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PicasaOutlinedSvg
  }));
};

PicasaOutlined.displayName = 'PicasaOutlined';
export default React.forwardRef(PicasaOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PicasaOutlined.js
// module id = 3786
// module chunks = 0